import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Package, ShoppingCart, Users, RefreshCw, DollarSign, MapPin } from 'lucide-react';
import './AdminDashboard.css';

const API = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/api/admin/stats`, {
        withCredentials: true
      });
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
      if (error.response?.status === 403) {
        alert('Admin access required');
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="spinner"></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>Admin Dashboard</h1>
        <p>Manage your House of Microgreens store</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon products">
            <Package size={32} />
          </div>
          <div className="stat-content">
            <h3>{stats?.totalProducts || 0}</h3>
            <p>Total Products</p>
          </div>
          <Link to="/admin/products" className="stat-link">Manage →</Link>
        </div>

        <div className="stat-card">
          <div className="stat-icon orders">
            <ShoppingCart size={32} />
          </div>
          <div className="stat-content">
            <h3>{stats?.totalOrders || 0}</h3>
            <p>Total Orders</p>
          </div>
          <Link to="/admin/orders" className="stat-link">View →</Link>
        </div>

        <div className="stat-card">
          <div className="stat-icon subscriptions">
            <RefreshCw size={32} />
          </div>
          <div className="stat-content">
            <h3>{stats?.activeSubscriptions || 0}</h3>
            <p>Active Subscriptions</p>
          </div>
          <Link to="/admin/subscriptions" className="stat-link">Manage →</Link>
        </div>

        <div className="stat-card">
          <div className="stat-icon users">
            <Users size={32} />
          </div>
          <div className="stat-content">
            <h3>{stats?.totalUsers || 0}</h3>
            <p>Total Users</p>
          </div>
          <Link to="/admin/users" className="stat-link">View →</Link>
        </div>

        <div className="stat-card revenue">
          <div className="stat-icon">
            <DollarSign size={32} />
          </div>
          <div className="stat-content">
            <h3>₹{stats?.totalRevenue || 0}</h3>
            <p>Total Revenue</p>
          </div>
        </div>
      </div>

      <div className="quick-actions">
        <h2>Quick Actions</h2>
        <div className="actions-grid">
          <Link to="/admin/products/new" className="action-card">
            <Package size={24} />
            <span>Add New Product</span>
          </Link>
          <Link to="/admin/orders" className="action-card">
            <ShoppingCart size={24} />
            <span>View Recent Orders</span>
          </Link>
          <Link to="/admin/subscriptions" className="action-card">
            <RefreshCw size={24} />
            <span>Manage Subscriptions</span>
          </Link>
          <Link to="/admin/users" className="action-card">
            <Users size={24} />
            <span>View Customers</span>
          </Link>
          <Link to="/admin/pincodes" className="action-card">
            <MapPin size={24} />
            <span>Manage Delivery Pincodes</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;